__turbopack_context__.v({
  "appOnlyBadge": "channelCardStrip-module-scss-module__9ce3IG__appOnlyBadge",
  "badgeStyles": "channelCardStrip-module-scss-module__9ce3IG__badgeStyles",
  "badgesContainer": "channelCardStrip-module-scss-module__9ce3IG__badgesContainer",
  "bannerTextStyles": "channelCardStrip-module-scss-module__9ce3IG__bannerTextStyles",
  "channelDescription": "channelCardStrip-module-scss-module__9ce3IG__channelDescription",
  "channelHeadline": "channelCardStrip-module-scss-module__9ce3IG__channelHeadline",
  "channelStripContainer": "channelCardStrip-module-scss-module__9ce3IG__channelStripContainer",
  "channelSubheadline": "channelCardStrip-module-scss-module__9ce3IG__channelSubheadline",
  "channelTitle": "channelCardStrip-module-scss-module__9ce3IG__channelTitle",
  "dotSeparator": "channelCardStrip-module-scss-module__9ce3IG__dotSeparator",
  "iconNotificationAndBannerText": "channelCardStrip-module-scss-module__9ce3IG__iconNotificationAndBannerText",
  "iconNotificationButton": "channelCardStrip-module-scss-module__9ce3IG__iconNotificationButton",
  "imageWrapper": "channelCardStrip-module-scss-module__9ce3IG__imageWrapper",
  "imageWrapperLink": "channelCardStrip-module-scss-module__9ce3IG__imageWrapperLink",
  "lockedButton": "channelCardStrip-module-scss-module__9ce3IG__lockedButton",
  "lockedButtonLink": "channelCardStrip-module-scss-module__9ce3IG__lockedButtonLink",
  "lockedOverlay": "channelCardStrip-module-scss-module__9ce3IG__lockedOverlay",
  "mainContainer": "channelCardStrip-module-scss-module__9ce3IG__mainContainer",
  "mainWrapper": "channelCardStrip-module-scss-module__9ce3IG__mainWrapper",
  "notificationShowContainer": "channelCardStrip-module-scss-module__9ce3IG__notificationShowContainer",
  "onAirWrapper": "channelCardStrip-module-scss-module__9ce3IG__onAirWrapper",
  "playButton": "channelCardStrip-module-scss-module__9ce3IG__playButton",
  "playButtonWrapper": "channelCardStrip-module-scss-module__9ce3IG__playButtonWrapper",
  "playbuttonLink": "channelCardStrip-module-scss-module__9ce3IG__playbuttonLink",
  "showAndScheduleLink": "channelCardStrip-module-scss-module__9ce3IG__showAndScheduleLink",
  "textContainer": "channelCardStrip-module-scss-module__9ce3IG__textContainer",
});
